import React from 'react'
import './ShoppingCategory.css'
import shopcat from './../../../Assets/images/shopcat.jpeg'
import catitem from './cate-item.svg'
export default function ShoppingCategory() {
  return (
    <section className='ShoppingCategory'>
        <div className="ShoppingCategory__container">
            <section className="ShoppingCategory__cart">
                <div className="ShoppingCategory__cart__content">
                    <div className="ShoppingCategory__cart__content__top">
                    <div className="ShoppingCategory__cart__content__title">
                        تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__subtitle">
                        دنیای تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__item">
                        <p>بهترین</p>
                        <p>جدیدترین</p>
                    </div>
                    </div>
                    <div className="ShoppingCategory__cart__content__image">
                    <img className='shop__cat__item' src={catitem} alt="" />
                        <img className='ShoppingCategory__cart__content__image__img' src={shopcat} alt="" />
                    </div>
                </div>
            </section>

            <section className="ShoppingCategory__cart">
                <div className="ShoppingCategory__cart__content">
                    <div className="ShoppingCategory__cart__content__top">
                    <div className="ShoppingCategory__cart__content__title">
                        تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__subtitle">
                        دنیای تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__item">
                        <p>بهترین</p>
                        <p>جدیدترین</p>
                    </div>
                    </div>
                    <div className="ShoppingCategory__cart__content__image">
                    <img className='shop__cat__item' src={catitem} alt="" />
                        <img className='ShoppingCategory__cart__content__image__img' src={shopcat} alt="" />
                    </div>
                </div>
            </section>

            <section className="ShoppingCategory__cart">
                <div className="ShoppingCategory__cart__content">
                    <div className="ShoppingCategory__cart__content__top">
                    <div className="ShoppingCategory__cart__content__title">
                        تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__subtitle">
                        دنیای تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__item">
                        <p>بهترین</p>
                        <p>جدیدترین</p>
                    </div>
                    </div>
                    <div className="ShoppingCategory__cart__content__image">
                    <img className='shop__cat__item' src={catitem} alt="" />
                        <img className='ShoppingCategory__cart__content__image__img' src={shopcat} alt="" />
                    </div>
                </div>
            </section>

            <section className="ShoppingCategory__cart">
                <div className="ShoppingCategory__cart__content">
                    <div className="ShoppingCategory__cart__content__top">
                    <div className="ShoppingCategory__cart__content__title">
                        تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__subtitle">
                        دنیای تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__item">
                        <p>بهترین</p>
                        <p>جدیدترین</p>
                    </div>
                    </div>
                    <div className="ShoppingCategory__cart__content__image">
                    <img className='shop__cat__item' src={catitem} alt="" />
                        <img className='ShoppingCategory__cart__content__image__img' src={shopcat} alt="" />
                    </div>
                </div>
            </section>

            <section className="ShoppingCategory__cart">
                <div className="ShoppingCategory__cart__content">
                    <div className="ShoppingCategory__cart__content__top">
                    <div className="ShoppingCategory__cart__content__title">
                        تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__subtitle">
                        دنیای تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__item">
                        <p>بهترین</p>
                        <p>جدیدترین</p>
                    </div>
                    </div>
                    <div className="ShoppingCategory__cart__content__image">
                    <img className='shop__cat__item' src={catitem} alt="" />
                        <img className='ShoppingCategory__cart__content__image__img' src={shopcat} alt="" />
                    </div>
                </div>
            </section>

            <section className="ShoppingCategory__cart">
                <div className="ShoppingCategory__cart__content">
                    <div className="ShoppingCategory__cart__content__top">
                    <div className="ShoppingCategory__cart__content__title">
                        تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__subtitle">
                        دنیای تم ووردپرس
                    </div>
                    <div className="ShoppingCategory__cart__content__item">
                        <p>بهترین</p>
                        <p>جدیدترین</p>
                    </div>
                    </div>
                    <div className="ShoppingCategory__cart__content__image">
                    <img className='shop__cat__item' src={catitem} alt="" />
                        <img className='ShoppingCategory__cart__content__image__img' src={shopcat} alt="" />
                    </div>
                </div>
            </section>
        </div>
        <div className="ShoppingCategory__container__button">
            <button className="ShoppingCategory__container__btn">
                مشاهده همه آیتم ها
            </button>
            </div>
    </section>
  )
}
